import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import PublicLayout from 'v2/components/Shared/PublicLayout';

const TokenExpired = () => {
  return (
    <PublicLayout>
      <Grid container direction='row' justify='center' alignItems='center'>
        <Grid item xs={12}>
          <Card>
            <CardContent style={{ textAlign: 'center', padding: 30 }}>
              <Typography variant='subtitle1'>Esse link está expirado ou inválido!</Typography>
              <Typography variant='subtitle2'>Solicite um novo link para troca de forma de pagamento.</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </PublicLayout>
  );
};

export default TokenExpired;
